import { GeneralSetting, LanguageShortTypes, LanguageTypes, UIAdaptedGeneralSetting } from '../interfaces';

const reverseLangIndex: Record<LanguageTypes, LanguageShortTypes> = {
  catalan: 'ca',
  spanish: 'es',
  english: 'en',
};

const normalLangIndex: Record<LanguageShortTypes, LanguageTypes> = {
  ca: 'catalan',
  es: 'spanish',
  en: 'english',
};

/**
 * Map in both directions the data.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export class GeneralSettingMapper {
  /**
   * Use it if you received data from server and
   * want to use it in Application Layer
   */
  public static fromBackendToUI(body: GeneralSetting): UIAdaptedGeneralSetting {
    const { language, theme } = body;
    return { theme, language: reverseLangIndex[language] };
  }

  /**
   * Use it if you want to send that info
   * from Application Layer to Domain Layer
   */
  public static fromUIToBackend(payload: UIAdaptedGeneralSetting): GeneralSetting {
    const { language, theme } = payload;
    return { theme, language: normalLangIndex[language] };
  }
}
